var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "newsletter-section", attrs: { id: "newsletter" } },
    [
      _c("section-header", {
        attrs: {
          "class-name": "newsletter-section__header",
          label: "Newsletter",
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _c("filter-button", {
                  attrs: {
                    items: _vm.tagFilters,
                    text: "Filter by tags",
                    name: "newsletter_filters",
                  },
                  on: { selected: _vm.filterHandler },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("content-slider", {
        staticClass: "newsletter-section__slider",
        attrs: { items: _vm.sliderData },
        scopedSlots: _vm._u([
          {
            key: "content-slider-item",
            fn: function ({ data }) {
              return [_c("post-card", { attrs: { post: data } })]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/components/NewsletterSection.vue